// 智能助手
import { createAPI } from '@common'

export default {
  // 获取智能体详情
  getAIAgentDetail: (config) => createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0joufmmjdpog0bhfou0efubjm', 'get', config),
  // 新建智能体
  addAIAgent: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0joufmmjdpog0bhfou0bee', 'post', config),
  // 修改智能体
  editAIAgent: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0joufmmjdpog0bhfou0feju', 'put', config),
  // 删除智能体
  deleteAIAgent: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0joufmmjdpog0bhfou0efmfuf', 'post', config),
  //获取智能问候语详情
  getAIGreetingDetail: (config) => createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0joufmmjdpog0hsffujoht0efubjm', 'get', config),
  // 新建智能问候语
  addAIGreeting: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0joufmmjdpog0hsffujoht0bee', 'post', config),
  // 修改智能问候语
  editAIGreeting: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0joufmmjdpog0hsffujoht0feju', 'put', config),
  // 删除智能问候语
  deleteAIGreeting: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0joufmmjdpog0hsffujoht0efmfuf', 'post', config),
  // 获取智能问候语设置
  getAIGreetingConfig: (config) => createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0joufmmjdpog0hsffujoht0dpogjh', 'get', config),
  // 智能问候语-设置
  configAIGreeting: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0joufmmjdpog0hsffujoht0dpogjh', 'post', config),
  // 智能问候语-通过
  passAIGreeting: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0joufmmjdpog0hsffujoht0qbtt', 'post', config),
  // 智能问候语-不通过
  rejectAIGreeting: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbqq0joufmmjdpog0hsffujoht0sfkfdu', 'post', config),
}
